export const editorColors = [
    ['#000000', '#555555', '#AAAAAA', '#FFFFFF'],
    ['#0033CC', '#3366FF', '#66A3FF', '#CCE0FF'],
    ['#CC0000', '#FF3333', '#FF8080', '#FFD6D6'],
    ['#007A00', '#33CC33', '#80E680', '#D6FFD6'],
    ['#FF8C00', '#FFB84D', '#FFD480', '#FFF2CC'],
    ['#6600CC', '#9933FF', '#C299FF', '#E6CCFF'],
];